/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import NumberFormat from '../../utils/NumberFormat';

// eslint-disable-next-line react/prop-types
function CustomTooltip({ payload, label, active }) {
  // eslint-disable-next-line react/prop-types
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`Mês: ${label}`}</p>
        <p className="desc">{`Receita Por Km: ${NumberFormat(
          payload[0].value
        )}`}</p>
      </div>
    );
  }

  return null;
}

function Example({ dados }) {
  const monthNames = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ];

  // Convertendo número do mês para abreviação
  const formattedData = dados.map((item) => ({
    ...item,
    mes: monthNames[item.mes - 1] || item.mes,
  }));

  return (
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer>
        <BarChart
          width={500}
          height={300}
          data={formattedData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="mes" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="ReceitaPorKm" fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

Example.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  dados: PropTypes.array.isRequired,
};

export default Example;
